import { Schema } from '@cfworker/json-schema';
import { LpIntegrationDirection } from '../lpAdapters.interface';

// Anything that knows its direction: an adapter of the list or the client schemas response.
interface IDirected {
  integrationDirection?: LpIntegrationDirection;
}

interface IConnectionSchemas {
  trading?: Schema | null;
}

// An unknown adapter (legacy LP, list not loaded) counts as outbound: the form keeps today's shape.
export const isInboundAdapter = (adapter?: IDirected | null): boolean => (
  adapter?.integrationDirection === LpIntegrationDirection.Inbound
);

// Only a loaded schema without `trading` disables the section; while the schema is
// unknown (undefined) or the adapter has none (null) the trading connection is kept.
export const isTradingDisabled = (schemas?: IConnectionSchemas | null): boolean => (
  schemas?.trading === null
);

// Parameters CP marks `readOnly: true`: shown, never edited, never sent back.
export const getReadOnlyParameterKeys = (schema?: Schema | null): Set<string> => {
  const properties = schema?.properties ?? {};

  return new Set(Object.entries(properties)
    .filter(([, property]) => typeof property === 'object' && property !== null && property['readOnly'] === true)
    .map(([key]) => key));
};
